var isNonEmptyString = function (value) {
    return typeof value === 'string' && value !== '';
};
var buildForSiteOwnerQuery = function (forSiteOwner) {
    if (isNonEmptyString(forSiteOwner.loggedInUserId) &&
        isNonEmptyString(forSiteOwner.siteOwnerId)) {
        return ('&' +
            "requestContext.forSiteOwner.loggedInUserId=".concat(forSiteOwner.loggedInUserId, "&") +
            "requestContext.forSiteOwner.siteOwnerId=".concat(forSiteOwner.siteOwnerId));
    }
    return '';
};
var buildForSiteVisitorsQuery = function (forSiteVisitors) {
    if (isNonEmptyString(forSiteVisitors.visitorId) &&
        isNonEmptyString(forSiteVisitors.siteOwnerId)) {
        return ('&' +
            "requestContext.forSiteVisitors.visitorId=".concat(forSiteVisitors.visitorId, "&") +
            "requestContext.forSiteVisitors.siteOwnerId=".concat(forSiteVisitors.siteOwnerId));
    }
    return '';
};
var buildOverrideCriteriaQuery = function (overrideCriteria) {
    if (isNonEmptyString(overrideCriteria.entityId)) {
        return "&requestContext.overrideCriteria.entityId=".concat(overrideCriteria.entityId);
    }
    return '';
};
export function getRequestContextQuery(requestContext) {
    if (requestContext === void 0) { requestContext = {}; }
    var forSiteOwner = requestContext.forSiteOwner, forSiteVisitors = requestContext.forSiteVisitors, overrideCriteria = requestContext.overrideCriteria;
    var query = '';
    var fieldsPassed = ['forSiteOwner', 'forSiteVisitors'].reduce(function (acc, cur) { return (requestContext[cur] ? acc + 1 : acc); }, 0);
    if (fieldsPassed > 1) {
        throw new Error('Only one of "forSiteOwner" or "forSiteVisitors" is accepted.');
    }
    if (forSiteOwner) {
        query += buildForSiteOwnerQuery(forSiteOwner);
    }
    if (forSiteVisitors) {
        query += buildForSiteVisitorsQuery(forSiteVisitors);
    }
    if (overrideCriteria) {
        query += buildOverrideCriteriaQuery(overrideCriteria);
    }
    return query;
}
//# sourceMappingURL=request-context.js.map